import React from 'react'

export function GreenCheckIcon (): React.JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM10.0898 5.71484L6.58984 9.21484L6.125 9.67969L5.66016 9.21484L3.91016 7.46484L3.44531 7L4.375 6.07305L4.83984 6.53789L6.125 7.82305L9.16016 4.78516L9.625 4.32031L10.552 5.25L10.0871 5.71484H10.0898Z" fill="#3B763D"/>
    </svg>
  )
}
